module.exports = __webpack_public_path__ + "img/img28.07eaebf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img28.jpg
// module id = 294
// module chunks = 0